/**
 * A mail service is never a business's own website.
 *
 * The signup website field is required, and a required field invites the
 * address someone signs in with. Crawling "gmail.com" left a new workspace
 * with an empty knowledge base and an abandoned setup, so it is refused here,
 * before a code is sent, with a message that says why.
 *
 * Mirrors EMAIL_PROVIDER_DOMAINS and EMAIL_PROVIDER_MESSAGE in
 * serviti-api/src/services/business_website.py. A test there keeps the two
 * identical, because the API refuses the same addresses at verify time.
 */
export const EMAIL_PROVIDER_DOMAINS = [
  'aol.com',
  'gmail.com',
  'gmx.com',
  'googlemail.com',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'mac.com',
  'mail.com',
  'mail.google.com',
  'me.com',
  'msn.com',
  'outlook.com',
  'proton.me',
  'protonmail.com',
  'rediffmail.com',
  'rocketmail.com',
  'yahoo.co.in',
  'yahoo.com',
  'yahoo.in',
  'yandex.com',
  'ymail.com',
  'zohomail.com',
  'zohomail.in',
];

export const EMAIL_PROVIDER_MESSAGE = 'That is an email provider, not your business website. Enter your business website, or your Instagram or Facebook page.';

/** The domain itself or any subdomain of it: www.gmail.com is gmail.com. */
export const isEmailProviderHost = (hostname) => {
  const host = (hostname || '').toLowerCase().replace(/\.$/, '');
  return EMAIL_PROVIDER_DOMAINS.some((domain) => host === domain || host.endsWith(`.${domain}`));
};

/**
 * What setup does with the website given at signup.
 *
 * Only a site the crawler can read is pre-filled. A social profile, or a mail
 * service stored before signup refused them, comes back empty, so that
 * business starts from pasted details instead. An API that predates the
 * website_crawlable flag sends none, and pre-filling carries on as before.
 */
export const setupWebsite = (progress, { additionalAgent = false } = {}) => {
  const website = additionalAgent ? '' : (progress?.website || '');
  const unreadable = Boolean(website) && progress?.website_crawlable === false;
  return { prefill: unreadable ? '' : website, unreadable };
};
